import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import {
  buildAuthPageLoaderMessages,
  buildPageLoaderBranding,
  WavvestPageLoader,
} from '@/common/components/page-loader';
import {
  getAdvisorLoginRouteFirmId,
  readAdvisorLoginBrandContextForAuthChrome,
} from './brandContext';

export const AdvisorLoginRouteLoader: FC = () => {
  const location = useLocation();
  const routeFirmId = getAdvisorLoginRouteFirmId(location.pathname, location.search);
  const cachedBranding = readAdvisorLoginBrandContextForAuthChrome(routeFirmId);

  return (
    <WavvestPageLoader
      branding={buildPageLoaderBranding(cachedBranding)}
      messages={buildAuthPageLoaderMessages()}
      showFallbackBranding={false}
    />
  );
};
